import { FC } from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

import { dateTimeFormat } from 'constants/formats';
import UsersArray from 'modules/profile/components/UsersArray';

import { Communication } from 'types';

import { useTranslate } from 'hooks/useTranslate';
import ToggleMenu from 'modules/_shared/components/ToggleMenu';
import { getRecipientsText } from '../../../components/utils';
import { useCommunicationsPage } from '../context/CommunicationsPageContext';

type CommunicaionsListRowProps = {
  index: number;
  communication: Communication;
};

const CommunicaionsListRow: FC<CommunicaionsListRowProps> = ({
  index,
  communication,
}) => {
  const { t } = useTranslate();
  const { data, actions } = useCommunicationsPage();

  const getRecipientsForBadge = () => {
    if (communication?.recipients?.length === 1) {
      const recipient = communication.recipients[0];
      return [
        {
          ...recipient,
          name: recipient.name || recipient.email,
        },
      ];
    }
    return communication?.recipients;
  };

  const handleOpenCommunication = () => {
    actions.handleOpenCommunication(index);
  };

  const handleDeleteCommunication = () => {
    actions.handleDeleteCommunication(index);
  };

  const recipientsText = getRecipientsText(
    communication?.recipients,
    communication?.presetGroup
  );

  const toggleOptions = [
    <a
      className="d-flex cursor-pointer"
      key={`communication-view-option-${index}`}
      onClick={handleOpenCommunication}
    >
      <em className="icon ni ni-eye fs-20px" />
      <span className="ml-1">{t('See')}</span>
    </a>,
    <a
      className="d-flex cursor-pointer"
      key={`communication-delete-option-${index}`}
      onClick={handleDeleteCommunication}
    >
      <em className="icon ni ni-trash fs-20px" />
      <span className="ml-1">{t('Delete')}</span>
    </a>,
  ];

  return (
    <div
      className={`nk-ibx-item ${communication?.isUnread ? 'is-unread' : ''}`}
      key={communication._id}
    >
      <div className="nk-ibx-item-elem nk-ibx-item-star d-none d-lg-flex">
        <Link
          to={`/detalle-comunicacion/${communication?.society}/${communication._id}/certificacion`}
          className="btn btn-icon btn-trigger"
        >
          <em className="icon ni ni-shield-check-fill text-soft" />
        </Link>
      </div>

      <div
        className="nk-ibx-item-elem nk-ibx-item-user d-none d-lg-block"
        onClick={handleOpenCommunication}
      >
        <div className="user-card d-flex align-items-center">
          <UsersArray
            users={getRecipientsForBadge()}
            show={1}
            size="w-40px"
            bgColor="bg-primary"
            linkField={undefined}
            linkPrefix={undefined}
          />
          <div className="user-name ml-1">
            <div className="lead-text">{t(`${recipientsText}`)}</div>
          </div>
        </div>
      </div>

      <div
        className="nk-ibx-item-elem nk-ibx-item-fluid"
        onClick={handleOpenCommunication}
      >
        <div className="nk-ibx-context-group">
          <div className="nk-ibx-context">
            <span className="nk-ibx-context-text">
              <span className="heading mr-1">{communication?.subject}</span>

              <span className="d-inline d-lg-inline">
                {communication?.bodySummary || ''}
              </span>
            </span>
          </div>
        </div>
      </div>

      <div
        className="nk-ibx-item-elem nk-ibx-item-attach d-none d-lg-flex"
        onClick={handleOpenCommunication}
      />

      <div className="d-none d-lg-flex  nk-ibx-item-elem nk-ibx-item-time">
        <div className="sub-text">
          {communication?.date
            ? format(new Date(communication.date), dateTimeFormat)
            : '-'}
        </div>
      </div>

      {!data.isReadOnly && <ToggleMenu toggleOptions={toggleOptions} />}
    </div>
  );
};

export default CommunicaionsListRow;
